import PortalConfiguration from "./PortalConfiguration"

export default PortalConfiguration;